import React from 'react'

const Info: React.FC = ({ children }) => {
  return <p className="my-4 italic">{children}</p>
}

export default Info
